import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { deleteStaff, getStaff } from '../../services/request.service';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { setPersonalToEdit } from '../../reducers/actions/request-actions';

const PersonalTable = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [showRequest, setShowRequest] = useState(true);
    const [allStaffs, setAllStaffs] = useState([])
    const auth = useSelector((state) => state.auth.user.id);

    useEffect(()=>{
      getStaff(auth).then((response)=>{
        setAllStaffs(response)
      })
    }, [])

    const handleDelete = async (StaffId, e) =>{
      Swal.fire({
        title: "¿Estas seguro?",
        text: "No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, bórralo!", 
      }).then((result) => {
        if (result.isConfirmed) {
          deleteStaff(StaffId)
        } else {
          Swal.fire("Cancelado!", "No se pudo procesar la solicitud", "error");
        }
      });
    }

    const handleEdit = (personal) => {
      dispatch(setPersonalToEdit(personal))
      navigate(`/request/addPersonal`)
    }

  return (
    <div className="container">
      <div className={`row g-3`}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h5 className="Request-form-h4">{"Personal visitante"}</h5>
          <NavLink
            to={"/request/addPersonal"}
            className="btn btn-success btn-sm"
          >
            Agregar
          </NavLink>
        </div>
        <div
          className={`${showRequest ? "show-request" : "no-show-request"}`}
        ></div>
        <div className="mobile-content-display">
          <ul
            className={`list-group ${
              showRequest ? "show-request" : "no-show-request"
            }`}
          >
            <ul className="list-group-item list-group-item-action d-none d-lg-inline-block border-bottom ul-request">
              <div className="row">
                <div className="col-lg list-request-title">
                  <strong>Nombre</strong>
                </div>
                <div className="col list-request-title">
                  <strong>Identificación</strong>
                </div>
                <div className="col list-request-title">
                  <strong>Fecha Nacimiento</strong>
                </div>
                <div className="col list-request-title">
                  <strong>Fecha Expedición</strong>
                </div>
                <div className="col list-request-title">
                  <strong>ARL</strong>
                </div>
                <div className="col list-request-title">
                  <strong>RH</strong>
                </div>
                <div className="col list-request-title"></div>
              </div>
            </ul>
            {allStaffs && allStaffs?.map((staff, index) => (
              <a
                key={index}
                className={`list-group-item list-group-item-action ul-request ${
                  showRequest ? "show-request" : "no-show-request"
                } ul-request`}
              >
                <div className="row">
                  <div className="col list-request-title">
                    <strong>{staff.name}</strong>
                  </div>
                  <div className="col col-lg">
                    <small className="d-lg-none mt-1">
                      Show
                      <br />
                    </small>
                    {staff.identification}
                  </div>
                  <div className="col col-lg">
                    <small className="d-lg-none mt-1">
                      Played By
                      <br />
                    </small>
                    {staff.birthDate}
                  </div>
                  <div className="col col-lg">
                    <small className="d-lg-none mt-1">
                      Played By
                      <br />
                    </small>
                    {staff.expeditionDate}
                  </div>
                  <div className="col col-lg">
                    <span className="d-lg-none">Rating: </span>
                    {staff.riskEntityName}
                  </div>
                  <div className="col col-lg">{staff.rh}</div>
                  <div className="col col-lg">
                    <button
                      className="btn btn-secondary"
                      onClick={() => handleEdit(staff)}
                      style={{ marginRight: "15px" }}
                    >
                      <i className="bi bi-pencil"></i>
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={(e) => (
                        e.preventDefault(), handleDelete(staff.id)
                      )}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </a>
            ))}
          </ul>
        </div>
        {allStaffs?.map((staff, index) => (
          <div
            key={index}
            className={`col-lg-4 mobile-content ${
              showRequest ? "show-request" : "no-show-request"
            }`}
          >
            <div className="card card-margin h-100">
              <div className="card-header no-border">
                <h5 className="card-title">{staff.name}</h5>
              </div>
              <div className="card-body pt-0">
                <div className="widget-49">
                  <div className="widget-49-title-wrapper">
                    <div className="widget-49-date-primary">
                      <span className="widget-49-date-day">
                        <i className="bi bi-person-fill"></i>
                      </span>
                    </div>
                    <div className="widget-49-meeting-info">
                      <span className="widget-49-pro-title">
                        {"Cedula de ciudadania"}
                      </span>
                      <span className="widget-49-meeting-time">{`CC. ${staff.identification}`}</span>
                    </div>
                  </div>
                </div>
                <div className="div-Buttons">
                  <button className="btn btn-success buttons btn-sm">
                    <i className="bi bi-pencil">Editar</i>
                  </button>
                  <button className="btn btn-danger buttons btn-sm">
                    <i className="bi bi-x">Eliminar</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PersonalTable